$("#search-tdb-info").on("click", function(){
  $.ajax({
    type: "GET",
    url: "http://localhost:3000/tdb_info?name_like=" + $("#tdb-info-name").val(),
    dataType: "json",
    success: function(result){
      let thead = '<tr class="c-lst_tr c-lst_head">' +
      '<th class="c-lst_th c-lst_th-cntr fixW-150">TDB企業コード</th>' +
      '<th class="c-lst_th c-lst_th-cntr fixW-150">企業ID</th>' +
      '<th class="c-lst_th c-lst_th-cntr fixW-150">紐付き企業ID</th>' +
      '<th class="c-lst_th c-lst_th-cntr fixW-150">作成区分</th>' +
      '<th class="c-lst_th c-lst_th-cntr">企業名</th></tr>'

      let rows = result.map(function(result){
        return '<tr class="c-lst_tr c-lst_itm">' +
               '<td class="c-lst_td c-lst_td-cntr">' + result.id + '</td>' +
               '<td class="c-lst_td c-lst_td-cntr">' + result.tdb_id + '</td>' +
               '<td class="c-lst_td c-lst_td-cntr">' + result.link_id + '</td>' +
               '<td class="c-lst_td c-lst_td-cntr">' + result.type + '</td>' +
               '<td class="c-lst_td">' + result.name + '</td></tr>'
      });

      $("table.c-lst").html(thead + rows);
    },
    error: function(result) {
      alert("TDB企業情報の取得に失敗しました。");
    }
  });
});
